import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import canonicalService from '../services/canonicalService';
import './CanonicalList.css';

const CanonicalList = () => {
  const [canonicals, setCanonicals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    loadCanonicals();
  }, []);

  const loadCanonicals = async () => {
    try {
      setLoading(true);
      setError(null);

      const filterParams = {};
      if (searchTerm) filterParams.name = searchTerm;

      const response = await canonicalService.getAllCanonicals(filterParams);
      setCanonicals(response.data.canonicals || []);
    } catch (err) {
      console.error('Error loading canonicals:', err);
      setError(err.response?.data?.message || err.message || 'Failed to load canonicals');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this canonical?')) {
      return;
    }

    try {
      await canonicalService.deleteCanonical(id);
      setCanonicals(canonicals.filter(c => c.id !== id));
    } catch (err) {
      console.error('Error deleting canonical:', err);
      alert(err.response?.data?.message || 'Failed to delete canonical');
    }
  };

  const handleSearch = () => {
    loadCanonicals();
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  if (loading) {
    return <div className="loading">Loading canonicals...</div>;
  }

  return (
    <div className="canonical-list-container">
      <div className="header">
        <h1>Canonical Management</h1>
        <button className="btn btn-primary" onClick={() => navigate('/admin/canonical/new')} title="Create New Canonical">
          ➕ Create New Canonical
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleSearchKeyPress}
        />
        <button className="btn btn-search" onClick={handleSearch}>
          Search
        </button>
        <button className="btn btn-secondary" onClick={() => { setSearchTerm(''); loadCanonicals(); }}>
          Clear
        </button>
      </div>

      <div className="table-container">
        <table className="canonical-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Created</th>
              <th>Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {canonicals.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">No canonicals found</td>
              </tr>
            ) : (
              canonicals.map((canonical) => (
                <tr
                  key={canonical.id}
                  onClick={() => navigate(`/admin/canonical/${canonical.id}`)}
                  className="clickable-row"
                  title="Click to view"
                >
                  <td>{canonical.name}</td>
                  <td>{new Date(canonical.created_at).toLocaleDateString()}</td>
                  <td>{new Date(canonical.updated_at).toLocaleDateString()}</td>
                  <td className="actions">
                    <button
                      className="btn btn-edit"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/admin/canonical/${canonical.id}/edit`);
                      }}
                      title="Edit"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn btn-delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(canonical.id);
                      }}
                      title="Delete"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CanonicalList;
